import { MenuItem } from "@mui/material";
import { Form } from "formik";
import * as yup from "yup";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import { FormikDateRangeInput, FormikDateRangeSearch } from "../../../commons/formik/formikDateRangeSearch";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextField from "../../../commons/formik/formikTextField";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledAppointmentsSearchForm } from "../../../styled/appointments";

const validationSchema = yup.object().shape({
  art: yup.string().required("El ART es obligatorio"),
  datePeriod: yup.string().optional(),
  startDate: yup
    .date()
    .required("La fecha desde es obligatoria")
    .typeError("Fecha inválida")
    .test(
      "startDate-before-endDate",
      "La fecha desde debe ser anterior a la fecha hasta",
      function (value) {
        const { endDate } = this.parent;
        if (value && endDate && new Date(value) > new Date(endDate)) {
          return false;
        }
        return true;
      },
    ),
  endDate: yup
    .date()
    .required("La fecha hasta es obligatoria")
    .typeError("Fecha inválida")
    .test(
      "endDate-after-startDate",
      "La fecha hasta debe ser posterior a la fecha desde",
      function (value) {
        const { startDate } = this.parent;
        if (value && startDate && new Date(value) < new Date(startDate)) {
          return false;
        }
        return true;
      },
    ),

  provider: yup
    .string()
    .nullable()
});

const AppointmentsSearchForm = ({
  isSearching,
  arts,
  estados,
  providers,
  initialValues,
  handleSubmitSearch,
  setIdArt,
  onArtChange,
  handleClearSearch
}) => {

  const handleOnArtChange = (artValue, setFieldValue) => {
    setIdArt(artValue);
    if (artValue && onArtChange) {
      onArtChange(artValue);
    }
    setFieldValue("provider", null);
  };

  const handleClear = (resetForm) => {
    handleClearSearch();
    resetForm({ values: initialValues });
  };

  return (
    <div>
      <StyledAppointmentsSearchForm.StyledPaper>
        {!isSearching ? (
          <FormikForm
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmitSearch}>
            {({ values, setFieldValue, resetForm }) => (
              <Form>
                <StyledAppointmentsSearchForm.StyledInput>
                  <FormikSelect
                    sx={{ mb: 2, mr: 2, width: 250 }}
                    name="art"
                    label="Art"
                    variant="standard"
                    callBack={(value) => handleOnArtChange(value, setFieldValue)}>
                    {arts.map((art) => (
                      <MenuItem value={art.id} key={art.id}>
                        {art.nombre}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </StyledAppointmentsSearchForm.StyledInput>
                <StyledAppointmentsSearchForm.StyledInput>
                  <FormikTextField
                    name="siniestro"
                    variant="standard"
                    label="Siniestro"
                    sx={{ mb: 2, mr: 2, width: 250 }}
                  />
                </StyledAppointmentsSearchForm.StyledInput>
                <StyledAppointmentsSearchForm.StyledInput>
                  <FormikTextField
                    name="dni"
                    label="DNI"
                    variant="standard"
                    sx={{ mb: 2, mr: 2, width: 250 }}
                  />
                </StyledAppointmentsSearchForm.StyledInput>
                <StyledAppointmentsSearchForm.StyledInput>
                  <FormikAutocomplete
                    name="provider"
                    label="Prestador"
                    variant="standard"
                    options={providers}
                    sx={{ mb: 2, mr: 2, width: 250 }}
                  />
                </StyledAppointmentsSearchForm.StyledInput>
                <StyledAppointmentsSearchForm.StyledInput>
                  <FormikSelect
                    name="state"
                    label="Estado"
                    variant="standard"
                    sx={{ mb: 2, mr: 2, width: 250 }}>
                    {estados.map((estado) => (
                      <MenuItem key={estado.id} value={estado.nombre}>
                        {estado.nombre}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </StyledAppointmentsSearchForm.StyledInput>
                <StyledAppointmentsSearchForm.StyledInput>

                  <FormikDateRangeSearch
                    name="datePeriod"
                    label="Período"
                    variant="standard"
                    sx={{ mb: 2, mr: 2, width: 250 }}
                  />

                </StyledAppointmentsSearchForm.StyledInput>

                <StyledAppointmentsSearchForm.StyledInput>
                  <FormikDateRangeInput
                    name="startDate"
                    label="Fecha Desde"
                    sx={{ mb: 2, mr: 2, width: 250 }}
                  />
                </StyledAppointmentsSearchForm.StyledInput>
                <StyledAppointmentsSearchForm.StyledInput>
                  <FormikDateRangeInput
                    name="endDate"
                    label="Fecha Hasta"
                    sx={{ mb: 2, mr: 2, width: 250 }}
                  />
                </StyledAppointmentsSearchForm.StyledInput>


                <StyledAppointmentsSearchForm.ButtonContainer>
                  <StyledAppointmentsSearchForm.StyledButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={isSearching}>
                    Buscar
                  </StyledAppointmentsSearchForm.StyledButton>
                  <StyledAppointmentsSearchForm.StyledButton
                    variant="contained"
                    type="button"
                    color="primary"
                    disabled={isSearching}
                    style={{ marginLeft: 8 }}
                    onClick={() => handleClear(resetForm)}>
                    Limpiar
                  </StyledAppointmentsSearchForm.StyledButton>
                </StyledAppointmentsSearchForm.ButtonContainer>
              </Form>
            )}
          </FormikForm>
        ) : (
          <CircularLoading />
        )}
      </StyledAppointmentsSearchForm.StyledPaper>
    </div>
  );
};

export default AppointmentsSearchForm;
